import { createElement } from 'react'
import { Link } from 'react-router'
import { Icon } from 'react-fa'

import { classesList } from 'utils'

import Z from 'components/Z'
import Raw from 'components/Raw'

// this file contains component factories. see here for
// more on info on react component factories:
// https://facebook.github.io/react/blog/2014/10/14/introducing-react-elements.html

// h is just an alias for React.createElement
export const h = createElement

// NOTE
// this is a quick and dirty factory, but really should
// be using the given React.createFactory. Currently with
// the old react-hot-loader it gives the error
//
// Warning: Factory.type is deprecated.
// Access the class directly before passing it to createFactory.
//
// when react-hot-loader 3 comes out, all of the below factory('...')
// should just be replaced with createFactory

export const factory = name =>
  (...args) => h(name, ...args)

export const div = factory('div')

export const h1 = factory('h1')
export const h2 = factory('h2')
export const h3 = factory('h3')
export const h4 = factory('h4')
export const h5 = factory('h5')
export const h6 = factory('h6')

export const p = factory('p')
export const a = factory('a')
export const span = factory('span')

export const img = factory('img')
export const svg = factory('svg')

export const strong = factory('strong')
export const em = factory('em')
export const i = factory('i')
export const u = factory('u')
export const b = factory('b')

export const label = factory('label')
export const input = factory('input')
export const textarea = factory('textarea')
export const select = factory('select')
export const option = factory('option')
export const button = factory('button')

export const main = factory('main')
export const section = factory('section')
export const aside = factory('aside')
export const header = factory('header')
export const footer = factory('footer')
export const nav = factory('nav')
export const article = factory('article')
export const address = factory('address')

export const br = factory('br')
export const hr = factory('hr')

export const ul = factory('ul')
export const ol = factory('ol')
export const li = factory('li')

export const table = factory('table')
export const thead = factory('thead')
export const tbody = factory('tbody')
export const tr = factory('tr')
export const th = factory('th')
export const td = factory('td')

export const dl = factory('dl')
export const dt = factory('dt')
export const dd = factory('dd')

// custom (our own components or 3rd-party components)

export const l = factory(Link)
export const z = factory(Z)
export const raw = factory(Raw)
export const icon = factory(Icon)

export const clearfix = () =>
  div(ca('clearfix'))

export const tsep = () =>
  span(ca('tsep'))

// helpers

// make a classes string intelligently
export function c (...args) {
  return classesList(...args).join(' ')
}

// make a classes string intelligently,
// then put it in a props object under className.
// it can be used like so:
// h('div', ca('foo', 'bar'))
// or if it has other props (using es6 spread operator):
// h('div', { onClick: noop, ...ca('foo', 'bar') })
export function ca (...args) {
  return { className: c(...args) }
}

// if show is truth-y, display element. otherwise, null.
export function maybe (show, el) {
  return show ? el : null
}



// WEBPACK FOOTER //
// ./resources/assets/js/h.js